import { render } from "./MyFileCard.vue?vue&type=template&id=07ef3cb2&scoped=true"
import script from "./MyFileCard.vue?vue&type=script&lang=js"
export * from "./MyFileCard.vue?vue&type=script&lang=js"

import "./MyFileCard.vue?vue&type=style&index=0&id=07ef3cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ef3cb2"]])

export default __exports__